/** Tab panel enter animation for Elite Plans landing (sell) tab switch. */
export const ELITE_PLANS_PANEL_ENTER_TRANSITION = {
  duration: 0.45,
  ease: [0.22, 1, 0.36, 1]
} as const

export const ELITE_PLANS_PANEL_MOTION_INITIAL = {
  opacity: 0,
  y: 40
} as const

export const ELITE_PLANS_PANEL_REDUCED_MOTION_TRANSITION = {
  duration: 0
} as const
